import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ComplianceUpdateModalUI from './ComplianceUpdateModalUI.js'

class ComplianceUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      status: '',
      statusError: null,
      remarks: '',
      remarksError: null,
      penaltyStatus: '',
      penaltyStatusError: null,
      cureDate: this.props.selectedLoanCompliance && this.props.selectedLoanCompliance.cureDateISO || '',
      cureDateError: null,
    }
  }

  render() {
    let statusList = [
      { key: 'complied', value: 'Complied' },
      { key: 'not_complied', value: 'Not complied' },
      { key: 'waived', value: 'Waived' },
      { key: 'not_applicable', value: 'Not Applicable' }
    ]
    let penaltyStatusList = [
      { key: 'waived', value: 'Waived' },
      { key: 'not_waived', value: 'Not Waived' }
    ];
    return (
      <ComplianceUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        status={this.state.status}
        onStatusChange={(event) => { this.setState({ status: event.target.value }) }}
        statusError={this.state.statusError}
        setStatusError={(error) => { this.setState({ statusError: error }) }}
        statusList={statusList}
        //
        remarks={this.state.remarks}
        onRemarksChange={(event) => { this.setState({ remarks: event.target.value }) }}
        remarksError={this.state.remarksError}
        setRemarksError={(error) => { this.setState({ remarksError: error }) }}
        //
        penaltyStatus={this.state.penaltyStatus}
        onPenaltyStatusChange={(event) => { this.setState({ penaltyStatus: event.target.value }) }}
        penaltyStatusError={this.state.penaltyStatusError}
        setPenaltyStatusError={(error) => { this.setState({ penaltyStatusError: error }) }}
        penaltyStatusList={penaltyStatusList}
        //
        cureDate={this.state.cureDate}
        onCureDateChange={(selectedDateISO) => { this.setState({ cureDate: selectedDateISO }) }}
        cureDateError={this.state.cureDateError}
        setCureDateError={(error) => { this.setState({ cureDateError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
  const selectedLoanCompliance = this.props.selectedLoanCompliance;
  if (!selectedLoanCompliance) return;

  if (
    !prevProps.selectedLoanCompliance ||
    prevProps.selectedLoanCompliance.loanComplianceId !== selectedLoanCompliance.loanComplianceId ||
    prevProps.selectedLoanCompliance.status !== selectedLoanCompliance.status
  ) {
    this.setState({
      status: selectedLoanCompliance.status || '',
      remarks: selectedLoanCompliance.remarks || '',
      cureDate: selectedLoanCompliance.cureDate || '',
      penaltyStatus: selectedLoanCompliance.penaltyStatus || '',
    });
  }
}



  // ---> Used Previously
  // onSubmit = () => {
  //   let submitted = this.state.submitted
  //   if (submitted) return

  //   this.setState({
  //     successMsg: null,
  //     errorList: [],
  //     submitted: true
  //   })

  //   RestApiUtils.put(this.props.context,
  //     `/api/su/loans/${this.props.loan.loanId}/compliances/${this.props.selectedLoanCompliance.loanComplianceId}`,
  //     this.onSubmitCallback, {
  //     status: this.state.status,
  //     remarks: this.state.remarks,
  //     cureDate: this.state.cureDate,
  //     penaltyStatus: this.state.penaltyStatus,
  //   })
  // }


    onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/compliances/v1/${encodeURIComponent(this.props.selectedLoanCompliance.legalLanguageCode)}`,
      this.onSubmitCallback, {
      status: this.state.status,
      remarks: this.state.remarks,
      cureDate: this.state.cureDate,
      penaltyStatus: this.state.penaltyStatus,
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 10)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default ComplianceUpdateModalSF
